/**
 * Multistep Checkout - Services Section
 *
 * @param {*} serviceSelector
 */

export const checkoutServiceSelect = (serviceSelector) => {
  serviceSelector.forEach((selector) => {
    let input = selector.querySelector(".input-qty-services"),
      btnMinus = selector.querySelector(".btn-minus-services"),
      btnPlus = selector.querySelector(".btn-plus-services");
    input.value = 0;
    // Bottone di decremento
    btnMinus.addEventListener("click", () => {
      if (parseInt(input.value) > 0) {
        removeServiceFromCart(serviceSelector, input, btnMinus);
      }
    });

    // Bottone di incremento
    btnPlus.addEventListener("click", () => {
      addServiceToCart(serviceSelector, input, btnMinus);
    });
  });

  // Inizializza data attribute del form add to cart
  parseServices(serviceSelector);
};

/**
 * Add Service to Cart
 *
 * @param {*} serviceSelector
 * @param {*} input
 * @param {*} btnMinus
 */

const addServiceToCart = (serviceSelector, input, btnMinus) => {
  input.stepUp();
  parseServices(serviceSelector);
  if (parseInt(input.value) > 0) {
    btnMinus.removeAttribute("disabled");
  }
};

/**
 * Remove Service From Cart
 *
 * @param {*} serviceSelector
 * @param {*} input
 * @param {*} btnMinus
 */

const removeServiceFromCart = (serviceSelector, input, btnMinus) => {
  input.stepDown();
  parseServices(serviceSelector);
  if (parseInt(input.value) === 0) {
    btnMinus.setAttribute("disabled", "");
  }
};

/**
 * Check selected services quantity
 *
 * @param {*} serviceSelector
 */

const parseServices = (serviceSelector) => {
  let total = 0,
    orderData = "";
  serviceSelector.forEach(function (selector) {
    let serviceValue = parseInt(selector.querySelector(".input-qty-services").value),
      serviceSpan = selector.parentElement.parentElement.children[2].children[0].children[0],
      servicePrice = parseFloat(serviceSpan.dataset.servicePrice).toFixed(2),
      serviceLabel = selector.parentElement.parentElement.parentElement.firstElementChild.innerHTML + ":";

    serviceLabel += selector.parentElement.parentElement.firstElementChild.innerHTML.trim();
    total += serviceValue;
    let serviceAdd = parseFloat(serviceValue * servicePrice).toFixed(2);
    if (serviceValue != 0) {
      serviceSpan.innerHTML = serviceAdd.toString();
    } else {
      serviceSpan.innerHTML = servicePrice.toString();
    }
    orderData += serviceLabel + "=" + serviceValue.toString() + "=" + servicePrice.toString() + "&";
  });
  document.getElementById("final-checkout-section").dataset.selectedServices = orderData.slice(0, -1);
};
